<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div class="burger-spacing mb-3">
          <h1 class="page-title">{{user.tostring}}</h1>
        </div>
        <show-actions
          :editItem=allowEdit
          :deleteItem=allowDelete
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.Firstname')"
                  :property="'firstname'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.Lastname')"
                  :property="'lastname'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.Username')"
                  :property="'username'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('user.PhoneNumber')"
                  :property="'phoneNumber'">
                </show-value-field>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-5">
                <show-value-field
                  :object="user"
                  :label="$t('Role')"
                  :property="'role'"
                  :need-translation="true">
                </show-value-field>
              </div>

            </div>

            <div class="row d-flex justify-content-between">
              <div class="col-md-6">
                <b-button variant="primary" class="mr-3 mt-1" @click="showUpdatePasswordModal">{{ $t('Account.UpdatePassword') }}</b-button>
                <b-button variant="secondary" class="mt-1" @click="logout">
                  <span v-if="!isLoading">{{ $t('Logout') }}</span>
                  <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                </b-button>
              </div>
              <div class="col-md-6 d-flex justify-content-end">
                <b-link class="align-self-center" @click="showDeleteAccountModal">{{ $t('Account.Delete') }}</b-link>
              </div>
            </div>

          </b-card>
        </div>

      </div>

    </b-container>

    <!-- Modal Change password -->
    <change-password-modal></change-password-modal>

    <!-- Modal Delete Account -->
    <delete-account-modal></delete-account-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import ShowActions from '../../components/b122/ShowActions'
import ChangePasswordModal from "./ChangePasswordModal"
import DeleteAccountModal from "./DeleteAccountModal.vue";
import ShowValueField from "../../components/b122/showFields/ShowValueField.vue";

export default {

  name: 'AccountShow',

  components: {
    ShowValueField,
    DeleteAccountModal,
    ChangePasswordModal,
    ShowActions
  },

  data () {
    return {
      allowDelete: false,
      allowEdit: true,
      userId: this.$store.getters.userId,
      user: {},
      isLoading: false
    }
  },

  computed: {
    getValue () {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },

    getValueArray () {
      return property => (this.user[property] && this.user[property].length) ? this.user[property].map(el => el.tostring).join(', ') : 'N/A'
    }

  },

  mounted () {
    this.fetchData()
  },

  methods: {
    fetchData () {
      this.fetchUser()
    },

    fetchUser () {
      api
        .get(`/account/getAccount`)
        .then(response => {
          this.user = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: '/',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'AccountEdit'
      })
    },

    showUpdatePasswordModal () {
      this.$bvModal.show('change-password-modal')
    },

    showDeleteAccountModal () {
      this.$bvModal.show('delete-account-modal')
    },

    async logout () {
      this.isLoading = true
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/account/AccountShow.vue